import { render, staticRenderFns } from "./offsetPage.vue?vue&type=template&id=5a92baf8&scoped=true&"
import script from "./offsetPage.vue?vue&type=script&lang=js&"
export * from "./offsetPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a92baf8",
  null
  
)

export default component.exports